<template>
  <spinner v-if="loading" class="car-spinner car-content-spinner" />
  <div v-else-if="requestError">
    {{$t('errors.unknown')}}
  </div>

  <div v-else class="car-workshop-details">

  <div class="car-offer-list-item car-location-details">
    <!-- <div class="car-image-container">
      <location-image class="car-vehicle__image--188x144" :img-width="'188'" :img-height="'144'" :offer="locationContainer" />
    </div> -->
    <div class="car-workshop-container">
      <span class="car-rating" v-if="location.userRating"><span class="car-rating-average">{{ getRatingAverage() }}</span><ratings class="car-rating" :rating="location.userRating"></ratings><span class="car-rating-count" v-if="location.userRatingCount">({{location.userRatingCount}})</span></span>
      <span class="car-workshop-name">{{location.name}}</span>
      <span class="car-address" v-html="getLocationAddress()"></span>
      <span class="car-phone" v-if="location.locationPropertyMap.SERVICE_COUNTER_PHONE">
        <span class="car-label">{{$t('offer.locationDetails.phone')}}:</span> <a :href="'tel:' + location.locationPropertyMap.SERVICE_COUNTER_PHONE[0].value">{{location.locationPropertyMap.SERVICE_COUNTER_PHONE[0].value}}</a>
      </span>
      <span class="car-phone" v-else-if="location.locationPropertyMap.CENTRAL_PHONE">
        <span class="car-label">{{$t('offer.locationDetails.phone')}}:</span> <a :href="'tel:' + location.locationPropertyMap.CENTRAL_PHONE[0].value">{{location.locationPropertyMap.CENTRAL_PHONE[0].value}}</a>
      </span>
      <span class="car-phone" v-else-if="location.locationPropertyMap.PHONE24">
        <span class="car-label">{{$t('offer.locationDetails.phone')}}:</span>
        <a :href="'tel:' + location.locationPropertyMap.PHONE24[0].value">{{location.locationPropertyMap.PHONE24[0].value}}</a>
      </span>
      <span class="car-email">
        <span class="car-label">{{$t('offer.locationDetails.email')}}:</span> <a :href="'mailto:' + location.notificationEmails[0]" v-if="location.notificationEmails">{{location.notificationEmails[0]}}</a>
      </span>
    </div>
  </div>
  </div>
</template>

<script>
import Ratings from '@/components/service-request/Ratings';
import locationApiService from '@/modules/simpleService/services/locationApiService';
// import locationImage from '@/components/offerSelection/LocationImage';
import Spinner from 'vue-simple-spinner';

export default {
  name: 'WorkshopDetails',
  props: {
    locationId: {
      required: true
    }
  },
  data() {
    return {
      locationContainer: {},
      loading: false,
      requestError: false
    }
  },
  created() {
    this.loading = true;
    this.requestError = false;

    locationApiService.getLocation(this.locationId)
      .then(res => {
        this.locationContainer = {
          location: res.data
        }
        this.location = res.data;
      })
      .catch(() => { this.requestError = true })
      .finally(() => { this.loading = false })
  },
  components: {
    // locationImage,
    Ratings,
    Spinner
  },
  methods: {
    getRatingAverage: function () {
      return `${parseFloat(this.location.userRating).toFixed(1)}`;
    },
    getLocationAddress: function () {
      return this.location.addressLabel.replace(',', '<br>');
    }
  }
}
</script>
